import { render, staticRenderFns } from "./VStack.vue?vue&type=template&id=a9f13d74&scoped=true"
import script from "./VStack.vue?vue&type=script&lang=ts"
export * from "./VStack.vue?vue&type=script&lang=ts"
import style0 from "./VStack.vue?vue&type=style&index=0&id=a9f13d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f13d74",
  null
  
)

export default component.exports